const HTML_ENTITIES = {
  amp: "&",
  lt: "<",
  gt: ">",
  quot: '"',
  apos: "'",
  nbsp: " ",
  hellip: "…",
  ndash: "–",
  mdash: "—",
  lsquo: "‘",
  rsquo: "’",
  ldquo: "“",
  rdquo: "”",
  pound: "£",
  euro: "€",
  bull: "•",
  middot: "·",
};

const decodeEntities = (str) =>
  str
    .replace(/&#(\d+);/g, (match, code) => String.fromCharCode(code))
    .replace(/&#x([0-9a-f]+);/gi, (match, code) => String.fromCharCode(parseInt(code, 16)))
    .replace(/&([a-z]+);/gi, (match, name) => HTML_ENTITIES[name.toLowerCase()] ?? match);

/**
 * Turns CMS rich text (job/blog descriptions) into a plain-text meta description.
 * Tags become spaces rather than being deleted, otherwise text either side of a block tag
 * runs together ("Engineer</p><p>We are" -> "EngineerWe are"), then entities are decoded and
 * whitespace collapsed. Only real tags are matched, so copy such as "FTC >£110K" survives.
 * The result never exceeds `length` and is trimmed on a word boundary, never mid-word.
 *
 * @param html
 * @param length
 * @returns {string}
 */
export const getMetaDescription = (html = "", length = 260) => {
  const text = decodeEntities(String(html || "").replace(/<!--[\s\S]*?-->|<\/?[a-zA-Z][^>]*>/g, " "))
    .replace(/\s+/g, " ")
    .trim();

  if (text.length <= length) {
    return text;
  }

  const cut = text.slice(0, length - 3); // room for the ellipsis
  const lastSpace = cut.lastIndexOf(" ");

  return `${(lastSpace > 0 ? cut.slice(0, lastSpace) : cut).replace(/[\s,;:.–—-]+$/, "")}...`;
};
